'use client'

import React from 'react'
import MuxPlayer from '@mux/mux-player-react'
import { cn } from '@/utilities/cn'

interface CourseVideoProps {
  video: {
    id: string
    title?: string
    muxPlaybackId?: string
    filename?: string
  }
  className?: string
  autoPlay?: boolean
  controls?: boolean
}

export const CourseVideo: React.FC<CourseVideoProps> = ({
  video,
  className,
  autoPlay = false,
  controls = true,
}) => {
  const { muxPlaybackId, filename, title } = video

  // If video has Mux playback ID, use Mux player
  if (muxPlaybackId) {
    return (
      <div className={cn('relative w-full overflow-hidden rounded-2xl shadow-xl ring-1 ring-border/30', className)}>
        <MuxPlayer
          playbackId={muxPlaybackId}
          controls={controls}
          autoPlay={autoPlay}
          style={{
            display: 'block',
            width: '100%',
            height: 'auto',
            aspectRatio: '16/9'
          }}
          title={title}
          placeholder="blur"
          accentColor="#3b82f6"
          thumbnailTime={0}
          maxResolution="2160p"
        />
      </div>
    )
  }

  // Fallback to standard video element for videos without Mux integration
  if (filename) {
    return (
      <div className={cn('relative w-full', className)}>
        <video
          className="w-full h-auto aspect-video rounded-lg"
          controls={controls}
          autoPlay={autoPlay}
          playsInline
        >
          <source src={`${process.env.NEXT_PUBLIC_SERVER_URL}/media/${filename}`} />
          Your browser does not support the video tag.
        </video>
      </div>
    )
  }

  // No video available
  return (
    <div className={cn('bg-gray-100 flex items-center justify-center p-8 rounded-lg aspect-video', className)}>
      <div className="text-center">
        <div className="text-gray-400 mb-4">
          <svg className="w-12 h-12 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
          </svg>
        </div>
        <p className="text-gray-600">Geen video beschikbaar</p>
      </div>
    </div>
  )
}